import React from 'react';
import '../../App.css';
import '../banner/bannerMain.css';
import '../innerBanner/innerbanner.css';
import { IMG_URL } from "../../config.js";
import dlogo from '../../images/dummy-logo.png';






function InnerBanner({ data }) {
  if (!data) return null; // safety check
  
  // Construct logos array dynamically from API data fields
  // Adjust field names to match your actual API
  const logos = [
    data.image2,
    data.image3,
    data.image44,
    data.image55,
  ].filter(Boolean); // filter out undefined or null values

  return (
    <section className="innerbanner banner-wrapp">
      <div className="banin-col1">
        {/* Banner Image */}
        <div className="banin-img">
          <img src={`${IMG_URL}/public/${data?.image1}`} alt="Banner Background" />
        </div>

        <div className="banin-col2">
          {/* Main Text */}
          <div className="banin-txt">
            <div className="banin-txtabt" dangerouslySetInnerHTML={{ __html: data?.maintitle }} />

            {/* Call-to-Action Buttons */}
            <div className="bann-cta">
              {data?.subtitle && (
                <a href="/registerpage" className="b-cta-btn1">{data.subtitle}</a>
              )}
              {data?.aboutuscon1 && (
                <a
                    href=""
                    style={{ cursor: "pointer" }}
                      onClick={(e) => {
                      e.preventDefault();
                      const el = document.getElementById("glance-wrapp");

                        if (el) {
                            const yOffset = -100;
                            const y =
                            el.getBoundingClientRect().top +
                            window.pageYOffset +
                            yOffset;

                            window.scrollTo({ top: y, behavior: "smooth" });
                        }
                    }}
                     
                    className="b-cta-btn2"
                     
                >{data.aboutuscon1}</a>
              )}
            </div>

            {/* Dynamic Logos from API */}
            <div className="bann-logo">
              {logos.map((logoSrc, index) => (
                <div key={index} className="logo-container">
                  <img src={`${IMG_URL}/public/${logoSrc}`} alt={`Logo ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>

          {/* Info Cards */}
          <div className="banin-cards-row">
            {data?.profile && (
              <div className="banin-cards" dangerouslySetInnerHTML={{ __html: data.profile }} />
            )}
            {data?.standing1 && (
              <div className="banin-cards" dangerouslySetInnerHTML={{ __html: data.standing1 }} />
            )}
            {data?.standing2 && (
              <div className="banin-cards" dangerouslySetInnerHTML={{ __html: data.standing2 }} />
            )}
            {data?.standing3 && (
              <div className="banin-cards" dangerouslySetInnerHTML={{ __html: data.standing3 }} />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default InnerBanner;
